














































































































































































import Vue from "vue";
import apiClient from "@/services/apiClient";
import moment from "moment";

export default Vue.extend({
  data() {
    return {
      moment,
      dialog: false,
      form: false,
      dialogDelete: false,
      ruleRequired: value => !!value || this.$t("REQUIRED"),
      headers: [
        { text: "KD", value: "name" },
        {
          text: "Phần trăm hoa hồng vận chuyển",
          value: "commission_vc",
          sortable: false
        },
        {
          text: "Phần trăm hoa hồng thanh toán",
          value: "commission_tt",
          sortable: false
        },
        {
          text: "Có hiệu lực từ tháng",
          value: "month",
          sortable: false
        },
        { text: this.$t("ACTIONS"), value: "actions", sortable: false }
      ],
      options: {},
      loading: false,
      data: [],
      dataCount: 0,
      editedIndex: -1,
      editedItem: {
        commission_vc: 0,
        commission_tt: 0
      },
      defaultItem: {
        commission_vc: 0,
        commission_tt: 0
      },
      kds: [],
      user: null
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Thêm mới" : this.$t("EDIT");
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  async created() {
    this.currentDate = moment().format("YYYY-MM");
    this.user = await apiClient.userGetById(this.$route.params.id);
    const { items } = await apiClient.userGetAll({
      rawOptions: {
        limit: -1
      },
      filters: [
        {
          key: "roles",
          operator: "match",
          value: "kd"
        }
      ]
    });
    this.kds = items;
  },
  methods: {
    async initialize() {
      this.loading = true;
      const items = await apiClient.getStaffByUser(this.$route.params.id);
      this.data = items;
      this.dataCount = items.length;
      this.loading = false;
    },
    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign(
        {},
        {
          staff_id: item.id,
          commission_vc: item.commission_vc,
          commission_tt: item.commission_tt
        }
      );
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign(
        {},
        {
          staff_id: item.id,
          commission_vc: item.commission_vc,
          commission_tt: item.commission_tt
        }
      );
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      this.closeDelete();
      await apiClient.removeStaffFromUser(
        this.$route.params.id,
        this.editedItem.staff_id
      );
      await this.initialize();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      let result;
      if (this.editedIndex > -1) {
        result = await apiClient.updateStaffOfUser(
          this.$route.params.id,
          this.editedItem.staff_id,
          this.editedItem
        );
      } else {
        result = await apiClient.addStaffToUser(
          this.$route.params.id,
          this.editedItem.staff_id,
          this.editedItem
        );
      }
      if (result) {
        this.close();
        await this.initialize();
      }
    }
  }
});
